module.exports = __webpack_public_path__ + "static/media/BrandonDavid_HERE-Safely.160cba00.pdf";